import React from 'react';
import { Radio } from 'semantic-ui-react';
import styled from 'styled-components';

import { ProjectClass } from '@/types/projectClass';
import { Service } from '@/types/service';

export type Props = {
  selected: number | undefined;
  list: Array<Service | ProjectClass>;
  onChange: (serviceId: number, checked: boolean) => void;
};

export const RadioButtons: React.FC<Props> = ({ list, selected, onChange }) => (
  <Styled>
    <div className="services">
      {list.map((item, i) => {
        const checked = selected === item.id;

        return (
          <label
            data-test={`service-${i}`}
            htmlFor={`service-${item.id}`}
            key={item.id}
          >
            <Segment className={checked ? 'service active' : 'service'}>
              <Radio
                className="radio-field"
                checked={checked}
                id={`service-${item.id}`}
                label={item.name}
                name="service"
                value={item.id}
                onChange={(e, data) => {
                  onChange(item.id, !!data.checked);
                }}
                radio={true}
              />
            </Segment>
          </label>
        );
      })}
    </div>
  </Styled>
);

const Segment = styled.div`
  padding: 14px;
  background-color: white;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  border: 1px solid rgba(34, 36, 38, 0.15);
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    border-color: #96c8da;
    box-shadow: 0 0 1px #96c8da;
  }
`;

const Styled = styled.div`
  .services {
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0;
    padding-top: 14px;
    padding-bottom: 11.4px;
    gap: 25.4px;
  }

  .services > label {
    width: 100%;
    white-space: nowrap;
  }

  .radio-field {
    vertical-align: text-top;
  }

  .service.active {
    border: 1px solid #2185d0;
    background-color: #f1f9ff;
  }
`;
